<template>
  <div
    class="tw:flex tw:justify-center tw:items-start tw:mx-auto tw:w-full tw:px-4 tw:md:max-w-screen-lg tw:lg:max-w-screen-xl"
  >
    <slot />
  </div>
</template>
